import { formatJson } from "./schemaOptimizerUtils";

function linesForSchema(value) {
	const text = formatJson(value);
	return text ? text.split("\n") : [];
}

function lcsTable(a, b) {
	const n = a.length;
	const m = b.length;
	const dp = Array.from({ length: n + 1 }, () => Array(m + 1).fill(0));
	for (let i = 1; i <= n; i += 1) {
		for (let j = 1; j <= m; j += 1) {
			if (a[i - 1] === b[j - 1]) {
				dp[i][j] = dp[i - 1][j - 1] + 1;
			} else {
				dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
			}
		}
	}
	return dp;
}

/** @returns {{ type: 'unchanged'|'added'|'removed', text: string }[]} */
export function diffLineOps(originalSchema, recommendedSchema) {
	const oldLines = linesForSchema(originalSchema);
	const newLines = linesForSchema(recommendedSchema);
	const dp = lcsTable(oldLines, newLines);
	const ops = [];
	let i = oldLines.length;
	let j = newLines.length;
	while (i > 0 || j > 0) {
		if (i > 0 && j > 0 && oldLines[i - 1] === newLines[j - 1]) {
			ops.push({ type: "unchanged", text: newLines[j - 1] });
			i -= 1;
			j -= 1;
		} else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
			ops.push({ type: "added", text: newLines[j - 1] });
			j -= 1;
		} else {
			ops.push({ type: "removed", text: oldLines[i - 1] });
			i -= 1;
		}
	}
	ops.reverse();
	return ops;
}

export function diffJsonStats(originalSchema, recommendedSchema) {
	const ops = diffLineOps(originalSchema, recommendedSchema);
	let unchanged = 0;
	let added = 0;
	let removed = 0;
	ops.forEach((op) => {
		if (op.type === "unchanged") unchanged += 1;
		else if (op.type === "added") added += 1;
		else removed += 1;
	});
	const replaced = Math.min(added, removed);
	return {
		unchanged,
		added,
		replaced,
		removed,
	};
}

/** Lines to render in recommended pane (skip pure removals). */
export function recommendedDisplayLines(originalSchema, recommendedSchema) {
	const oldLines = linesForSchema(originalSchema);
	const newLines = linesForSchema(recommendedSchema);
	const dp = lcsTable(oldLines, newLines);
	const ops = [];
	let i = oldLines.length;
	let j = newLines.length;
	while (i > 0 || j > 0) {
		if (i > 0 && j > 0 && oldLines[i - 1] === newLines[j - 1]) {
			ops.push({ type: "unchanged", text: newLines[j - 1], newLineIndex: j - 1 });
			i -= 1;
			j -= 1;
		} else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
			ops.push({ type: "added", text: newLines[j - 1], newLineIndex: j - 1 });
			j -= 1;
		} else {
			ops.push({ type: "removed", text: oldLines[i - 1], newLineIndex: null });
			i -= 1;
		}
	}
	ops.reverse();

	const rows = [];
	let lineNum = 0;
	ops.forEach((op) => {
		if (op.type === "removed") return;
		lineNum += 1;
		rows.push({
			lineNum,
			newLineIndex: op.newLineIndex,
			type: op.type,
			text: op.text,
			marker: op.type === "added" ? "+" : " ",
		});
	});
	return rows;
}
